import React from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { toggleCutOffTime, toggleCutOffEnable } from "store/actions";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { CONTENT } from "consts";
import { outlineFocus } from "utils";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";

function Advanced(props) {
  const hours = [];
  const minutes = [];

  if (props.cutOffTime) {
    for (let i = 0; i <= 23; i++) {
      hours.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
    for (let i = 0; i <= 55; i = i + 5) {
      minutes.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
  }

  return (
    <div className="schedule_backup_advance">
      <div className="sub_title">
        <p>Advanced</p>
      </div>

      <div className="input_checkboxw cut_off_row just_flex cutoff-blk">
        <div className="check">
          <input
            type="checkbox"
            className="input_checkbox"
            id="schedule_backup_1"
            defaultChecked={props.cutOffTime.isEnabled}
            onChange={() =>
              props.toggleCutOffEnable(!props.cutOffTime.isEnabled)
            }
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_1_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_1_label", 0);
            }}
          />
          <label htmlFor="schedule_backup_1" id="schedule_backup_1_label" />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleCutOffEnable(!props.cutOffTime.isEnabled)}
        >
          Cut-off Time:{" "}
        </p>
        <div className="cow_box ">
          <div className="cutt-off_wrap flex_align ">
            <div className="hours_mins_wrap flex_align ">
              <div
                className="hours_wrap flex_align transparent_layer_wrap"
                style={{ marginRight: "10px" }}
              >
                {!props.cutOffTime.isEnabled ? (
                  <div
                    className="transparent_layer"
                    style={{ opacity: "0.5" }}
                  ></div>
                ) : (
                  ""
                )}
                <div className="hh_mm_div">HH</div>
                <div className="main_select">
                  <select
                    onChange={e => props.toggleCutOffTime(e.target.value, "hr")}
                    value={Math.trunc(props.cutOffTime.value / 3600)}
                  >
                    {hours}
                  </select>
                </div>
              </div>
              <div className="mins_wrap flex_align transparent_layer_wrap">
                {!props.cutOffTime.isEnabled ? (
                  <div
                    className="transparent_layer"
                    style={{ opacity: "0.5" }}
                  ></div>
                ) : (
                  ""
                )}
                <div className="hh_mm_div">MM</div>
                <div className="main_select">
                  <select
                    onChange={e => props.toggleCutOffTime(e.target.value, "mn")}
                    value={Math.trunc((props.cutOffTime.value % 3600) / 60)}
                  >
                    {minutes}
                  </select>
                </div>
              </div>
              <Tooltip {...TOOLTIPS.backupSettings.schedule.cutOff}>
                <span className="icon">
                  <InformationIcon />
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>

      <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => {
            props.toggleScheduleDevice("preventSleep");
          }}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.scheduleInfo.advanced.preventSleep &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_5"
            defaultChecked={props.scheduleInfo.advanced.preventSleep}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_5_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_5_label", 0);
            }}
          />
          <label
            htmlFor="schedule_backup_5"
            id="schedule_backup_5_label"
          ></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() => {
            props.toggleScheduleDevice("preventSleep");
          }}
        >
          {CONTENT.backupSettings.backupSchedule.advance.hibernate}
        </p>
      </div>

      {/* <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => props.toggleScheduleDevice("performShutdown")}
        >
          <input
            type="checkbox"
            className="input_checkbox"
            id="schedule_backup_3"
            defaultChecked={props.scheduleInfo.advanced.performShutdown}
          />
          <label htmlFor="schedule_backup_3"></label>
        </div>
        <p className="checkbox_p">
          {CONTENT.backupSettings.backupSchedule.advance.shutdown}
        </p>
      </div> */}

      <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => props.toggleScheduleDevice("runMissed")}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.scheduleInfo.advanced.runMissed &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_2"
            defaultChecked={props.scheduleInfo.advanced.runMissed}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_2_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_2_label", 0);
            }}
          />
          <label htmlFor="schedule_backup_2" id="schedule_backup_2_label" />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleScheduleDevice("runMissed")}
        >
          {CONTENT.backupSettings.backupSchedule.advance.startup}
        </p>
      </div>

      <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => props.toggleScheduleDevice("onWakeup")}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.scheduleInfo.advanced.onWakeup.checked &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_3"
            defaultChecked={props.scheduleInfo.advanced.onWakeup.checked}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_3_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_3_label", 0);
            }}
          />
          <label htmlFor="schedule_backup_3" id="schedule_backup_3_label" />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleScheduleDevice("onWakeup")}
        >
          {CONTENT.backupSettings.backupSchedule.advance.wakeup}
        </p>
      </div>

      {/* <div
        className={[
          "login_pass",
          "just_flex transparent_layer_wrap",
          "transparent_layer_login_pass",
          props.scheduleInfo.advanced.onWakeup.checked ? "layer_active" : null,
        ].join(" ")}
      >
        <div className="transparent_layer" />
        <div className="lp_item just_flex">
          <p>{CONTENT.backupSettings.backupSchedule.advance.creds.username}</p>
          <div className="err_msg_wrap">
            <input
              type="text"
              className="input_text"
              value={props.scheduleInfo.advanced.onWakeup.userName}
              onChange={(e) =>
                props.toggleScheduleLoginDetails("userName", e.target.value)
              }
            />
            {!sPopupState.validation.status &&
              sPopupState.validation.params.emptyUserName && (
                <div>
                  <span className="error-msg active">
                    {sPopupState.validation.params.emptyUserName.msg}
                  </span>
                </div>
              )}
          </div>
        </div>
        <div className="lp_item just_flex">
          <p>{CONTENT.backupSettings.backupSchedule.advance.creds.pwd}</p>
          <div className="err_msg_wrap">
            <input
              type="password"
              className="input_password"
              value={props.scheduleInfo.advanced.onWakeup.password}
              onChange={(e) =>
                props.toggleScheduleLoginDetails("password", e.target.value)
              }
            />
            {!sPopupState.validation.status &&
              sPopupState.validation.params.emptyPassword && (
                <div>
                  <span className="error-msg active">
                    {sPopupState.validation.params.emptyPassword.msg}
                  </span>
                </div>
              )}
          </div>
        </div>
      </div> */}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    cutOffTime: state.backupSettings.cutOffTime
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleCutOffTime,
      toggleCutOffEnable
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Advanced);
